import classNames from 'classnames';
import React, { ReactElement } from 'react';

import { IMaybeParentProps } from '../../shared/types/IMaybeParentProps';
import { IQATestableProps } from '../../shared/types/IQATestableProps';
import { IStyleableProps } from '../../shared/types/IStyleableProps';

import { SKELETON_BOX_SIZE } from './SKELETON_BOX_SIZE';
import styles from './SkeletonBox.module.css';
import { OzSkeletonLoadingBar } from './SkeletonLoadingBar';

const sizes: {[key: string]: string} = {
    [SKELETON_BOX_SIZE.SIZE_1]: 'h-1',
    [SKELETON_BOX_SIZE.SIZE_2]: 'h-2',
    [SKELETON_BOX_SIZE.SIZE_3]: 'h-3',
    [SKELETON_BOX_SIZE.SIZE_4]: 'h-4',
    [SKELETON_BOX_SIZE.SIZE_5]: 'h-5',
    [SKELETON_BOX_SIZE.SIZE_6]: 'h-6',
    [SKELETON_BOX_SIZE.SIZE_7]: 'h-7',
    [SKELETON_BOX_SIZE.SIZE_8]: 'h-8',
};

export type ISkeletonBoxProps = IMaybeParentProps & IQATestableProps & IStyleableProps & {
    size?: SKELETON_BOX_SIZE;
};

export function OzSkeletonBox (props: ISkeletonBoxProps): ReactElement {
    const {
        'data-testid': dataTestId,
        className = '',
        size,
        children,
    }: ISkeletonBoxProps = props;

    const skeletonClassNames: string = classNames({
        'relative': !className.includes('absolute'),
        [className]: !!className,
        [sizes[size + '']]: !!sizes[size + ''],
    });

    return (
        <div data-testid={dataTestId} className={skeletonClassNames}>
            <OzSkeletonLoadingBar />
            <div className={styles.skeletonContainer}>
                {children}
            </div>
        </div>
    );
}
